import React, { useState, Fragment } from 'react';
import Localize from 'react-intl-universal';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import style from '@components/Filters/style/Filters.module.scss';

const StyledTextField = styled(TextField)(({ theme }) => ({
  padding: 0,
  color: theme.palette.primary.main,
  '& .MuiInputBase-input.MuiOutlinedInput-input': {
    padding: '0.5rem 1rem'
  }
}));

const filterOptions = (label, searchedValue) =>
  label.toLowerCase().includes(searchedValue.toLowerCase());

const CheckboxFilterGroup = ({
  title = '',
  showSearch = false,
  opened = false,
  handleOnChange = () => {},
  values = {},
  groupName = '',
  disabled = false,
  options = [],
  isFilterLoading = false
}) => {
  const [openAccordion, setOpenAccordion] = useState(opened);
  const [searchValue, setSearchValue] = useState('');

  const onAccordionClick = () => {
    if (!disabled) {
      setOpenAccordion((prevState) => !prevState);
    }
  };

  const onSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <Fragment key={groupName}>
      <Box data-testid={`CheckboxFilterGroup-${groupName}`} sx={{ mb: 1 }}>
        <Accordion
          expanded={openAccordion}
          onChange={onAccordionClick}
          data-testid={`accordionFilterGroup-${groupName}`}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${groupName}-content`}
            id={`panel-${groupName}-header`}
          >
            <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {options?.length > 0 && showSearch && (
              <StyledTextField
                fullWidth
                sx={{ paddingBottom: '1rem' }}
                variant='outlined'
                placeholder={title}
                value={searchValue}
                onChange={onSearchChange}
                InputProps={{
                  endAdornment: <SearchIcon color='action' />
                }}
              />
            )}
            {options?.length ? (
              <Box>
                {options
                  ?.filter(({ value }) => (searchValue ? filterOptions(value, searchValue) : true))
                  ?.map(({ value, key, realValue }, index) =>
                    value ? (
                      <FormControlLabel
                        sx={{ display: 'block' }}
                        key={`${groupName}-${value}-${index || 0}`}
                        control={
                          <Checkbox
                            data-testid={`checkbox-${key || index}`}
                            checked={Boolean(values[realValue ? realValue : value])}
                            onChange={(e) => {
                              handleOnChange(e, groupName);
                            }}
                            name={realValue ? realValue : value}
                          />
                        }
                        label={value}
                      />
                    ) : null
                  )}
              </Box>
            ) : isFilterLoading ? (
              <Box
                display='flex'
                justifyContent='center'
                alignItems='center'
                sx={{ minHeight: '5rem' }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Typography className={style.padding}>
                {Localize.get('CustomerLoyaltyEvents.noFilter')}
              </Typography>
            )}
          </AccordionDetails>
        </Accordion>
      </Box>
    </Fragment>
  );
};

export default CheckboxFilterGroup;
